import { Controller, useFormContext } from "react-hook-form";
import { useValidators } from "../../helpers/validation";
import { PhoneNumber } from "../../api/models/mainservice";
import { SUPPORTED_PREFIX } from "../../helpers/phoneHelper";
import Select from "../select/Select";

interface PhoneInputProps {
  name: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}

const PhoneInput = ({
  name,
  disabled,
  placeholder,
  required,
}: PhoneInputProps) => {
  const validators = useValidators();
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error } = getFieldState(name, formState);

  return (
    <div className="mb-2">
      <Controller<Record<string, PhoneNumber>>
        name={name}
        control={control}
        rules={{
          validate: (value) => validators.validatePhoneNumber(value, required),
        }}
        render={({ field }) => {
          const value = field.value || {
            prefix: SUPPORTED_PREFIX[0].numberPrefix,
            number: "",
          };

          return (
            <div className="PhoneInput flex flex-row">
              <Select
                onChange={(x) =>
                  x &&
                  !Array.isArray(x) &&
                  field.onChange({ ...field.value, prefix: x.value })
                }
                options={SUPPORTED_PREFIX.map((x) => ({
                  label: x.numberPrefix,
                  value: x.numberPrefix,
                }))}
                value={{
                  label: value.prefix,
                  value: value.prefix,
                }}
                className="w-[150px]"
              />
              <input
                id={name}
                autoComplete="mobile tel-local-suffix"
                className={`text-secondary w-full rounded-r-[10px] border bg-white px-4 py-3 text-base/[20px] autofill:bg-white ${
                  invalid
                    ? "border-error text-error placeholder-error"
                    : "border-gray-accent placeholder-secondary-light hover:border-secondary focus:border-secondary focus:outline-hidden"
                }`}
                type="tel"
                placeholder={placeholder}
                value={value.number}
                onBlur={field.onBlur}
                disabled={disabled}
                onChange={(e) =>
                  field.onChange({ ...value, number: e.target.value })
                }
              />
            </div>
          );
        }}
      />
      {error && isDirty && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default PhoneInput;
